module.exports = __webpack_public_path__ + "img/home2.ab881ebd.png";